import { createPath, parsePath, type Path, type To } from 'react-router-dom';

export function preserveCurrentSearch(to: To, searchParams: URLSearchParams): Partial<Path> {
  const target = typeof to === 'string' ? parsePath(to) : { ...to };

  if (target.search !== undefined) {
    return target;
  }

  const query = searchParams.toString();
  return query ? { ...target, search: `?${query}` } : target;
}

export function createHrefWithCurrentSearch(to: To, searchParams: URLSearchParams) {
  return createPath(preserveCurrentSearch(to, searchParams));
}
